import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification, Modal } from 'antd'
import actions from './actions'
import { SAVE_200_MSG, SAVE_200_DESC, DEL_200_MSG, DEL_200_DESC } from '../../constants'
import { list, find, save, remove } from '../../services/workOrderTravelCost'

function* fetchWorkOrderTravelCostsRefresh() {
  const fe = JSON.parse(localStorage.getItem('fetchWorkOrderTravelCosts'))
  if (fe == null) {
    fe.size = 10
    fe.index = 0
    fe.searchTerm = '%20'
    fe.orderBy = '%20'
  }
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, fe.size, fe.index, fe.searchTerm, fe.orderBy)
  yield put({
    type: actions.LIST_WORKORDERTRAVELCOST,
    result,
  })
}

function* fetchWorkOrderTravelCosts({ size, index, searchTerm, orderBy }) {
  // Load last params froom last session.
  if (!size && !index && !searchTerm && !orderBy) {
    const fe = JSON.parse(localStorage.getItem('fetchWorkOrderTravelCosts'))
    if (fe != null) {
      size = fe.size || 10
      index = fe.index || 0
      searchTerm = fe.searchTerm || '%20'
      orderBy = fe.orderBy || '%20'
    } else {
      size = 10
      index = 0
      searchTerm = '%20'
      orderBy = '%20'
    }
  }
  localStorage.setItem(
    'fetchWorkOrderTravelCosts',
    JSON.stringify({ size, index, searchTerm, orderBy }),
  )
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, size, index, searchTerm, orderBy)
  yield put({
    type: actions.LIST_WORKORDERTRAVELCOST,
    result,
  })
}

function* fetchWorkOrderTravelCostEdit({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(find, id)
  yield put({
    type: actions.EDIT_WORKORDERTRAVELCOST,
    result,
  })
}

function* fetchWorkOrderTravelCostSave(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(save, values)
  // A plain-string result is the backend's refusal (e.g. ELIN of another contract
  // year) - show it instead of the success toast.
  if (typeof result === 'string' && result.trim() !== '') {
    Modal.error({ title: 'Error', content: result, centered: true })
  } else if (result !== null) {
    notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
  }
  yield put({
    type: actions.SAVE_WORKORDERTRAVELCOST_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_WORKORDERTRAVELCOSTS,
  })
  yield put({ type: 'WorkOrder/GET_COSTVIEW2', id: values.values.workOrderID })
  yield put({ type: 'WorkOrders/FETCH_WORKORDER_COSTVIEW', id: values.values.workOrderID })
  yield put({ type: 'WorkOrderOperationCosts/FETCH' })
}

function* fetchWorkOrderTravelCostDelete(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(remove, values)
  if (result !== null) {
    notification.success({ message: DEL_200_MSG, description: DEL_200_DESC })
  }
  yield put({
    type: actions.DELETE_WORKORDERTRAVELCOST_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_WORKORDERTRAVELCOSTS,
  })
  yield put({ type: 'WorkOrder/GET_COSTVIEW2', id: values.values.workOrderID })
  yield put({ type: 'WorkOrders/FETCH_WORKORDER_COSTVIEW', id: values.values.workOrderID })
  yield put({
    type: 'FETCH_WORKORDER_BUDGETS',
    workOrderID: values.values.workOrderID,
    contractID: values.values.contractID,
  })
  yield put({ type: 'WorkOrderOperationCosts/FETCH' })
  yield put({ type: 'WorkOrderAdditionalCosts/FETCH' })
  yield put({ type: 'WorkOrder/GET_COSTVIEW2', id: values.values.workOrderID })
  yield put({ type: 'WorkOrders/FETCH_WORKORDER_COSTVIEW', id: values.values.workOrderID })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_WORKORDERTRAVELCOSTS, fetchWorkOrderTravelCosts),
    takeEvery(actions.FETCH_WORKORDERTRAVELCOST, fetchWorkOrderTravelCostEdit),
    takeEvery(actions.SAVE_WORKORDERTRAVELCOST, fetchWorkOrderTravelCostSave),
    takeEvery(actions.DELETE_WORKORDERTRAVELCOST, fetchWorkOrderTravelCostDelete),
    takeEvery(actions.RE_FETCH_WORKORDERTRAVELCOSTS, fetchWorkOrderTravelCostsRefresh),
  ])
}
